"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getFinalisedEpochReportForMultipleBlsKeys = exports._getValidatorDetails = void 0;
const graphql_request_1 = require("graphql-request");
const constants_1 = require("./constants");
const utils_1 = require("./utils");
const axios_1 = __importDefault(require("axios"));
const _getValidatorFromSubgraph = (signer, blsPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const chainID = yield (0, constants_1._extractChainID)(signer);
    const lsdUrls = (0, constants_1._getChainSpecificConstants)(chainID).lsdUrls;
    const lookupQuery = (0, graphql_request_1.gql) `
        query Knot($blsPublicKey: String!) {
            lsdvalidators(where:{
              id: $blsPublicKey
            }) {
              smartWallet {
                id
                nodeRunner {
                  id
                }
                liquidStakingNetwork {
                  id
                  ticker
                  feeRecipientAndSyndicate
                }
              }
              status
            }
        }
	`;
    const response = yield (0, graphql_request_1.request)(lsdUrls.SUBGRAPH_ENDPOINT, lookupQuery, {
        blsPublicKey: (0, utils_1._add0x)(blsPublicKey.toLowerCase())
    });
    if (!response || !response.lsdvalidators) {
        throw new Error('Invalid response getting the validators indexes');
    }
    return response.lsdvalidators[0];
});
const _getValidatorDetails = (signer, blsPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield _getValidatorFromSubgraph(signer, blsPublicKey);
        const feeRecipient = res.smartWallet.liquidStakingNetwork.feeRecipientAndSyndicate;
        const smartWallet = res.smartWallet.id;
        const nodeRunner = res.smartWallet.nodeRunner.id;
        const lsd = res.smartWallet.liquidStakingNetwork.ticker;
        const status = res.status;
        const liquidStakingManager = res.smartWallet.liquidStakingNetwork.id;
        return {
            liquidStakingManager, feeRecipient, nodeRunner, smartWallet, status, lsd
        };
    }
    catch (e) {
        return;
    }
});
exports._getValidatorDetails = _getValidatorDetails;
const _getFinalisedEpochReportForMultipleBlsKeys = (signer, beaconNodeURL, blsPublicKeys, status) => __awaiter(void 0, void 0, void 0, function* () {
    if (status == null) {
        status = ["active"];
    }
    let validStates = ["pending_initialized", "pending_queued", "active_ongoing", "active_exiting", "active_slashed", "exited_unslashed", "exited_slashed", "withdrawal_possible", "withdrawal_done", "active", "pending", "exited", "withdrawal"];
    for (let i = 0; i < status.length; ++i) {
        if (!validStates.includes(status[i])) {
            throw new Error("Error: Invalid validator states");
        }
    }
    const numberOfBLSKeys = blsPublicKeys.length;
    const batchLength = 75;
    let blsKeyToEpochReport = {};
    let beaconChainReports = [];
    const client = axios_1.default.create({ baseURL: beaconNodeURL });
    let response = yield client.get('/eth/v1/beacon/states/head/finality_checkpoints');
    const apiData = response.data;
    const { finalized } = apiData.data;
    const checkpointEpoch = parseInt(finalized.epoch);
    try {
        for (let i = 0; i < Math.ceil(numberOfBLSKeys / batchLength); ++i) {
            let query = "";
            let blsPublicKeysBatch = blsPublicKeys.slice(i * batchLength, Math.min(numberOfBLSKeys, (i + 1) * batchLength));
            for (let j = 0; j < blsPublicKeysBatch.length; ++j) {
                if (j == (blsPublicKeysBatch.length - 1)) {
                    query = query + "id=" + blsPublicKeysBatch[j];
                    for (let k = 0; k < status.length; ++k) {
                        query = query + "&status=" + status[k];
                    }
                }
                else {
                    query = query + "id=" + blsPublicKeysBatch[j] + "&";
                }
            }
            response = yield client.get('/eth/v1/beacon/states/finalized/validators?' + query);
            let validatorData = [];
            validatorData = response.data.data;
            for (let j = 0; j < validatorData.length; ++j) {
                const { balance, validator, index } = validatorData[j];
                const { pubkey, withdrawal_credentials, effective_balance, slashed, activation_eligibility_epoch, exit_epoch, withdrawable_epoch } = validator;
                blsKeyToEpochReport[pubkey] = {
                    validatorIndex: index,
                    blsPublicKey: pubkey.slice(2),
                    withdrawalCredentials: withdrawal_credentials.slice(2),
                    slashed,
                    activeBalance: balance,
                    effectiveBalance: effective_balance,
                    exitEpoch: exit_epoch,
                    activationEpoch: activation_eligibility_epoch,
                    withdrawalEpoch: withdrawable_epoch,
                    currentCheckpointEpoch: checkpointEpoch
                };
            }
        }
        const chainID = yield (0, constants_1._extractChainID)(signer);
        const lsdUrls = (0, constants_1._getChainSpecificConstants)(chainID).lsdUrls;
        const lookupQuery = (0, graphql_request_1.gql) `
        query getLastDepositIndex($ids: [String!]) {
          stakehouseAccounts(where:{id_in: $ids}) {
            id
            lastDepositDepositCount
          }
        }
      `;
        const ids = Object.keys(blsKeyToEpochReport).map(x => x.toLowerCase());
        const lookupResponse = yield (0, graphql_request_1.request)(lsdUrls.STAKEHOUSE_SUBGRAPH_ENDPOINT, lookupQuery, {
            ids: ids
        });
        if (!lookupResponse || !lookupResponse.stakehouseAccounts) {
            throw new Error('Invalid response getting lastDepositDepositCount');
        }
        for (let i = 0; i < lookupResponse.stakehouseAccounts.length; ++i) {
            beaconChainReports.push(Object.assign(Object.assign({}, blsKeyToEpochReport[lookupResponse.stakehouseAccounts[i].id]), { lastDepositIndex: lookupResponse.stakehouseAccounts[i].lastDepositDepositCount }));
        }
        beaconChainReports.sort((a, b) => {
            return blsPublicKeys.indexOf(`0x${a.blsPublicKey}`) - blsPublicKeys.indexOf(`0x${b.blsPublicKey}`);
        });
        return beaconChainReports;
    }
    catch (e) {
        throw new Error('Error: Failed to get finalised epoch reports');
    }
});
exports._getFinalisedEpochReportForMultipleBlsKeys = _getFinalisedEpochReportForMultipleBlsKeys;
